import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_tal" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of1 gfu-1of2--l" }
const _hoisted_4 = {
  class: "gfu-grid__cell gfu-1of1 _cf",
  "data-qa": "create-creator-account:url"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "gfu-grid__cell gfu-1of1 gfu-1of4--l gfu-left-3of4--l" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_url_field = _resolveComponent("url-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_text_field, {
            modelValue: $data.model.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.name) = $event)),
            name: "model.name",
            "display-name": "Your creator profile display name",
            disabled: $props.readOnly,
            onKeyup: _withKeys($options.onSubmit, ["enter"]),
            "data-qa": "create-creator-account:name"
          }, null, 8 /* PROPS */, ["modelValue", "disabled", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_url_field, _mergeProps({
            modelValue: $data.model.urlName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.urlName) = $event))
          }, $options.urlModel, {
            name: "model.urlName",
            "display-name": "Your creator profile address",
            "validator-layout": "default",
            layout: "condensed",
            onConfirmChange: $options.onConfirmUrlChange,
            onStartEditing: $options.onStartUrlEditing,
            onCancelEditing: $options.onCancelUrlEditing,
            "data-qa": "new-project-wizard:ProjectUrl"
          }), _createSlots({ _: 2 /* DYNAMIC */ }, [
            ($data.model.name)
              ? {
                  name: "edit",
                  fn: _withCtx(({ onEditClick }) => [
                    _createElementVNode("a", {
                      href: "",
                      class: "gfu-link gfu-link--accent _ml-1 _lhh",
                      onClick: _withModifiers(onEditClick, ["prevent"]),
                      "data-qa": "new-project-wizard-button:PickUrl"
                    }, [
                      _createVNode(_component_base_icon, { name: "pen" }),
                      _cache[2] || (_cache[2] = _createTextVNode(" edit URL", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_5)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["modelValue", "onConfirmChange", "onStartEditing", "onCancelEditing"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_base_button, {
            type: "button",
            width: "wide",
            theme: "accent",
            display: "block",
            class: "_mt-3",
            enabled: !$props.readOnly,
            onClick: _withModifiers($options.onSubmit, ["prevent"]),
            "data-qa": "create-account-button:Continue"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Continue", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "onClick"])
        ])
      ])
    ]),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}